import React from "react";
import styled from "styled-components";
export const KeyValue = (props) => {
    const { label, value } = props;
    return (React.createElement(Wrapper, null,
        React.createElement(Label, null, label),
        React.createElement(Value, null, value)));
};
const Wrapper = styled.div `
  display: flex;
  flex: 1;
  margin-bottom: ${(props) => `${props.theme.space[2]}px`};
  flex-direction: column;
`;
const Label = styled.p `
  color: ${(props) => props.theme.colors.dashboardColors.keyValueLabelText};
  margin: 0;
  font-size: ${(props) => `${props.theme.fontSizes[1]}px`};
  font-weight: 600;
`;
const Value = styled.div `
  color: ${(props) => props.theme.colors.dashboardColors.keyValueValueText};
  margin: 0;
  font-size: ${(props) => `${props.theme.fontSizes[1]}px`};
`;
